export const title = {
    borderBottom: "2px solid white"
};

export const backBtn = {
    color: "white"
};
